/**
 * Custom Redux middleware.
 * Add logging, analytics, or error tracking middleware here.
 *
 * @example
 * const loggerMiddleware = (store) => (next) => (action) => {
 *   console.log('Dispatching:', action.type);
 *   return next(action);
 * };
 */
const loggerMiddleware = (store) => (next) => (action) => {
    if (import.meta.env.DEV) {
        console.groupCollapsed(`Redux Action: ${action.type}`);
        console.log('Payload:', action.payload);
        console.log('State before:', store.getState());
        const result = next(action);
        console.log('State after:', store.getState());
        console.groupEnd();
        return result;
    }
    return next(action);
};

export const customMiddleware = [
    // Add middleware here. Logger runs only in dev.
    ...(import.meta.env.DEV ? [loggerMiddleware] : []),
];
